import { DASHBOARD_URL } from "@/lib/links";

export default function Hero() {
  return (
    <section className="hero wrap" data-testid="hero-section">
      <div className="hero-kicker mono">Real-time AI sales copilot</div>

      <h1 data-testid="hero-headline">
        The intelligence layer behind <span className="accent">sales teams</span>
      </h1>

      <p className="hero-copy">
        ThinkWire gives sales teams{" "}
        <strong>live answers, objection support and the next best action</strong> while the buyer is
        on the line. Every call becomes structured knowledge and clear follow-through.
      </p>

      <div className="hero-actions">
        <a
          className="btn btn-dark"
          href={DASHBOARD_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-cta-button"
        >
          Get started <span className="arrow">→</span>
        </a>
        <a className="btn" href="#workflow" data-testid="hero-secondary-cta">
          Explore the workflow
        </a>
      </div>

      <div className="hero-proof">
        <span>
          <i />
          Live call assistance
        </span>
        <span>
          <i />
          Conversation intelligence
        </span>
        <span>
          <i />
          Automated follow-through
        </span>
      </div>
    </section>
  );
}
